import { render, staticRenderFns } from "./PieChart.vue?vue&type=template&id=3ee2061e"
import script from "./PieChart.vue?vue&type=script&lang=ts"
export * from "./PieChart.vue?vue&type=script&lang=ts"
import style0 from "./PieChart.vue?vue&type=style&index=0&id=3ee2061e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports